<script setup>
import {ref, computed, onBeforeMount} from "vue";
import YTCard from "@/components/YTCard/newIndex.vue";
import YTAvatarUpload from "@/components/YTAvatarUpload/index.vue";
import boxUpload from "@/components/YTBoxUpload/index.vue"
import {tagsScenarioList} from "@/api/tag/tag.js";
import BoxUpload from "@/components/YTBoxUpload/index.vue";

const props = defineProps({
  // 是否编辑模式
  isEdit: {
    type: Boolean,
    default: false
  },
  // 双向绑定值
  modelValue: {
    required: true,
    type: Object,
  },
})
const emit = defineEmits(['success'])
onBeforeMount(async () => {
  await getSkillTags()
})
// 加载状态
const loading = ref(false)

/*表单相关*/
// 表单锚点
const ruleFormRef = ref()
// 表单信息，实现「双向绑定」
const ruleForm = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:modelValue', val)
})
// 技能证书校验规则
const checkSkillCertificates = (rule, value, callback) => {
  if (ruleForm.value.skillCertificates.length === 0) return callback(new Error("请至少上传一张技能证书"))
  return callback()
}
// 车店店员头像校验规则
const checkImagesList = (rule, value, callback) => {
  const listLength = avatarUploadRef.value.fileList.length
  if (listLength < 1) {
    return callback(new Error('请上传一张车店店员头像'))
  }
  callback()
}
// 车店店员姓名校验规则
const checkName = (rule, value, callback) => {
  if (!ruleForm.value.name) {
    return callback(new Error('请填写姓名（中文）'))
  }
  if (!ruleForm.value.nameEn) {
    return callback(new Error('请填写姓名（English）'))
  }
  callback()
}
// 默认校验规则
const rulesOne = {
  avatar: [
    {required: true, validator: checkImagesList, trigger: "blur"},
  ],
  name: [
    {required: true, validator: checkName, trigger: 'blur'},
  ],
  phone: [
    {required: true, message: '请填写手机号', trigger: 'blur'},
  ],
  skillCertificates: [
    {required: true, validator: checkSkillCertificates, trigger: 'change'},
  ]
}
// 表单校验规则
const rules = ref(rulesOne)
// 表单校验
const submit = () => {
  loading.value = true
  ruleFormRef.value.validate((valid, fields) => {
    if (valid) {
      createTherapist()
    } else {
      ElMessage.error("请根据提示修改表单信息")
      loading.value = false
    }
  })
}
// 创建车店店员
const createTherapist = () => {
  console.log("ruleForm", ruleForm.value)
  emit("success")
}
// 车店店员技能特点
const skillTags = ref([])
// 获取车店店员技能特点标签
const getSkillTags = async () => {
  try {
    loading.value = true
    let page = {
      page: 1,
      pageSize: 100,
    }
    const res = await tagsScenarioList(page, {usageScenario: "BIKE_STORE_CLERK_SKILL"})
    skillTags.value = res.list
    skillTags.value.map(tag => {
      tag.checked = false
    })
    if (props.isEdit) handleReviewTagList()
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 处理技能特点改变
const handleSkillTagsChange = (tag) => {
  console.log("tag", tag)
  tag.checked = !tag.checked
  let temp = []
  skillTags.value.map(i => {
    if (i.checked) temp.push(i.tagId)
  })
  ruleForm.value.tagIdList = temp
}

/*上传图片组件相关*/
// Logo图片上传组件锚点
const avatarUploadRef = ref();
// 处理logo上传成功
const handlePicSuccess = (url) => {
  ruleForm.value.avatar = null;
  ruleForm.value.avatar = url[0];
  console.log("url",url)
  console.log("url[0]",url[0])
  ruleFormRef.value.validateField("avatar");
  loading.value = false;
};
// 处理Logo图片反显
const handleReviewPic = (reviewList) => {
  avatarUploadRef.value.handleReview(reviewList);
};
// 处理技能特点反显
const handleReviewTagList = () => {
  skillTags.value.map(i => {
    if (ruleForm.value.tagIdList.includes(i.tagId)) i.checked = true
  })
}

/*中英文切换输入框相关Tab*/
// 理疗师名称tab
const nameTab = ref("zh")
// 介绍tab
const descriptionTab = ref("zh")

defineExpose({
  handleReviewPic,
  handleReviewTagList
})
</script>

<template>
  <div class="create_wrapper">
    <el-form
        ref="ruleFormRef"
        :model="ruleForm"
        :rules="rules"
        style="height: 100%;width: 100%;"
        class="flex"
        size="large"
    >
      <div class="create_wrapper flex_1">
        <YTCard :title="`车店店员信息`">
          <template #container>
            <el-form-item prop="avatar">
              <YTAvatarUpload :ali-oss-path="'SERVICE_PROVIDER_AVATAR_IMG_PATH'"
                              ref="avatarUploadRef"
                              :title="'头像'"
                              :isReplaceMode="true"
                              :isLogoMode="true"
                              :limit="1"
                              :width="80"
                              :height="80"
                              :file-size="1"
                              :isRequired="true"
                              :tips="``"
                              @progress="loading = true"
                              @success="handlePicSuccess"
              ></YTAvatarUpload>
            </el-form-item>
            <el-form-item label="姓名：" prop="name">
              <el-tabs
                  v-model="nameTab"
                  type="card"
                  class="demo-tabs"
              >
                <el-tab-pane label="中文" name="zh">
                  <el-input v-model="ruleForm.name" style="max-width: 800px;" placeholder="姓名"/>
                </el-tab-pane>
                <el-tab-pane label="English" name="en">
                  <el-input v-model="ruleForm.nameEn" style="max-width: 800px;" placeholder="name"/>
                </el-tab-pane>
              </el-tabs>
            </el-form-item>
            <el-form-item label="手机号：" prop="phone">
              <el-input maxlength="11" v-model="ruleForm.phone" style="max-width: 800px;" placeholder="手机号"/>
            </el-form-item>
            <el-form-item label="性别：" prop="gender">
              <el-radio-group v-model="ruleForm.gender">
                <el-radio :value="'MAN'">男</el-radio>
                <el-radio :value="'WOMAN'">女</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="介绍：" prop="description">
              <el-tabs
                  v-model="descriptionTab"
                  type="card"
                  class="demo-tabs"
              >
                <el-tab-pane label="中文" name="zh">
                  <el-input v-model="ruleForm.description" style="max-width: 800px;width: 400px" type="textarea" :rows="5" resize="none" maxlength="200" show-word-limit placeholder="介绍"/>
                </el-tab-pane>
                <el-tab-pane label="English" name="en">
                  <el-input v-model="ruleForm.descriptionEn" style="max-width: 800px;width: 400px" type="textarea" :rows="5" resize="none" maxlength="600" show-word-limit placeholder="description"/>
                </el-tab-pane>
              </el-tabs>
            </el-form-item>
          </template>
        </YTCard>
        <YTCard :title="`技能特点信息`">
          <template #container>
            <el-form-item label="技能特点：" prop="tagIdList">
              <el-check-tag :disabled="ruleForm.tagIdList?.length >= 10 && !tag.checked" class="mg_r_1 mg_b_1" v-for="(tag, index) in skillTags" :key="`skillTags${index}`" :checked="tag.checked" type="primary" @change="handleSkillTagsChange(tag)">
                {{tag.tagName}}
              </el-check-tag>
            </el-form-item>
          </template>
        </YTCard>
        <div class="flex_left mg_b_2 mg_l_2">
          <v-btn color="primary" @click="submit">保存</v-btn>
        </div>
      </div>
    </el-form>
  </div>
</template>

<style lang="scss" scoped>
.create_wrapper {
  width: 100%;
  height: 100%;
  background-color: #fff;
  overflow: auto;
}
</style>
